import React, { Component } from "react";
import TwoColumns from "../TwoColumns/TwoColumns";
import Input from "../Input/Input";
import "./TeamMemberInput.css";
import Button from '../Button/Button';
import { genderOptions, gradeOptions, validEmail } from "../../config";
import classNames from 'classnames';

export default class TeamMemberInput extends Component {

	componentDidMount() {
		// console.log('p',this.props.isValid);
	}

	componentDidUpdate() {
		// console.log('p',this.props.isValid);
	}

	classes() {
		return classNames({
			"team-member-input": true,
			"-contracted" : !this.props.expanded,
			"-expanded" : this.props.expanded,
			"-invalid": !this.props.isValid
		});
	}

	render() {
		const {
			expanded,
			firstName,
			lastName,
			gender,
			grade,
			schoolName,
			emailAddress,
			consentForm,
			mobileNumber,
			dateOfBirth,
			primaryContact,
			handleInputEvent,
			removeSelf,
			toggleSelf,
			handleDateInputEvent,
			handlePrimaryContactEvent,
			isValid
		} = this.props;
		
		if (!expanded) {
			return (
				<div className={this.classes()}>
				<div className="title">
				{(firstName || lastName) && <h3>{firstName} {lastName}</h3>}
				{!firstName && !lastName && <h3>New Team Member</h3>}
				{primaryContact && <span className="tag">Main Contact</span>}
				{!isValid && <span className="tag -warning">Incomplete</span>}
				{isValid && <span className="tag -primary">Complete</span>}
				</div>
				<div className="actions">
				<Button type={["primary","small"]} onClick={toggleSelf} >Edit</Button>
				<Button type="small"
				onClick={e => {
					e.stopPropagation();
					removeSelf();
				}}
				>
				Remove
				</Button>
				</div>
				</div>
			);
		}
		
		return (
			<div className={this.classes()}>

			<div className="name">
				{(firstName || lastName) && <h3 >{firstName} {lastName}</h3>}
				{(!firstName && !lastName) && <h3 >New Person</h3>}
				{!isValid && <span className="tag -warning">Incomplete</span>}
				{isValid && <span className="tag -primary">Complete</span>}
			</div>

			<TwoColumns
			left={
				<div>
				<Input
				title="First Name"
				value={firstName}
				onChange={e => handleInputEvent(e, "firstName")}
				onBlur={this.props.handleUpdate}
				validate={value => value}
				/>
				<Input
				title="Last Name"
				value={lastName}
				onChange={e => handleInputEvent(e, "lastName")}
				onBlur={this.props.handleUpdate}
				validate={value => value}
				/>
				<Input
				title="Gender"
				value={gender}
				type="dropdown"
				options={{
					"": "Select One",
					...genderOptions
				}}
				onChange={e => handleInputEvent(e, "gender")}
				onBlur={this.props.handleUpdate}
				validate={value => value}
				/>
				<Input
				title="Grade"
				value={grade}
				type="dropdown"
				options={{
					"": "Select One",
					...gradeOptions
				}}
				onChange={e => handleInputEvent(e, "grade")}
				onBlur={this.props.handleUpdate}
				validate={value => value}
				/>
				<Input
				title="Email Address"
				type="email"
				value={emailAddress}
				onChange={e => handleInputEvent(e, "emailAddress")}
				onBlur={this.props.handleUpdate}
				validate={email => validEmail.test(String(email).toLowerCase())}
				/>
				<Input
				title="Mobile Number"
				value={mobileNumber}
				onChange={e => handleInputEvent(e, "mobileNumber")}
				onBlur={this.props.handleUpdate}
				validate={value => value}
				/>
				<Input
				title="Date of Birth"
				value={dateOfBirth}
				onChange={data => handleDateInputEvent(data, "dateOfBirth")}
				type="datepicker"
				onBlur={this.props.handleUpdate}
				validate={value => value}
				/>
				</div>
			}
			right={
				<div>
				<Input
				title="This person is the team's main contact"
				value={primaryContact}
				type="checkbox"
				onChange={e => handlePrimaryContactEvent(e)}
				/>
				<Input
				title="School Name"
				value={schoolName}
				onChange={e => handleInputEvent(e, "schoolName")}
				onBlur={this.props.handleUpdate}
				validate={value => value}
				/>
				<Input
				title="Student Entry Form"
				value={consentForm}
				type="file"
				onComplete={filename =>
					this.props.handleFileUpload(filename, "consentForm")
				}
				filePath={`consentforms/${this.props.entryId}/${
					this.props.teamMemberId
				}/`}
				validate={value => value}
				/>
				<p className="-fineprint">If you haven’t got a Student Entry Form for {firstName ? firstName : 'this team member'}, you can download one <a href="https://prismic-io.s3.amazonaws.com/videosforchange%2F413bfbf3-3d11-44bc-b1de-23b362c44261_180705_student+entry+form+%281%29.pdf" target="_blank" rel="noopener noreferrer">here</a></p>
				</div>
			}
			/>
			<div className="actions">
				{/* <Button type={["small"]} onClick={e => { this.props.toggleSelf }}>Close</Button> */}
				<Button type="small"
				onClick={e => {
					e.stopPropagation();
					removeSelf();
				}}
				>
				Remove
				</Button>
			</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/TeamMemberInput/TeamMemberInput.js